const vstColors = {
    colors: {
        BRICK: '#d24634',
        CHEDDAR: '#eb710b',
        PICKLE: '#7e9e06',
        JUNGLE: '#1a9c6e',
        OCEAN: '#007fad',
        MIST: '#4f7e87',
        MAGIC: '#425ba1',
        EGGPLANT: '#684182',
        SANGRIA: '#d81e5d',
        CLOUD: '#757575',
        NINJA: '#2f2f39',
        CHERRY: '#f54250',
        GRASS: '#21a921',
        IRIDIUM: '#424247'
    },
    tints: {
        /** Brick */
        BRICK_1: '#fae6e3',
        BRICK_2: '#fac3bb',
        BRICK_3: '#faa094',
        BRICK_4: '#fa7d6d',
        BRICK_5: '#f75f4b',
        BRICK_6: '#eb4f3b',
        BRICK_7: '#d24634',
        BRICK_8: '#b83e2e',
        BRICK_9: '#9e3528',
        BRICK_10: '#852d21',

        /** Cheddar */
        CHEDDAR_1: '#fef3e9',
        CHEDDAR_2: '#fedbbd',
        CHEDDAR_3: '#fec491',
        CHEDDAR_4: '#fead64',
        CHEDDAR_5: '#ff993f',
        CHEDDAR_6: '#f58525',
        CHEDDAR_7: '#eb710b',
        CHEDDAR_8: '#e06107',
        CHEDDAR_9: '#ca500f',
        CHEDDAR_10: '#b0430c',

        /** Pickle */
        PICKLE_1: '#f4f6ea',
        PICKLE_2: '#e0eab8',
        PICKLE_3: '#ccdea7',
        PICKLE_4: '#b7d155',
        PICKLE_5: '#a3c523',
        PICKLE_6: '#91b215',
        PICKLE_7: '#7e9e06',
        PICKLE_8: '#698505',
        PICKLE_9: '#556b04',
        PICKLE_10: '#415203',

        /** Jungle */
        JUNGLE_1: '#e8f7f2',
        JUNGLE_2: '#c0eadb',
        JUNGLE_3: '#86e0c2',
        JUNGLE_4: '#55d5a9',
        JUNGLE_5: '#24c991',
        JUNGLE_6: '#1fb380',
        JUNGLE_7: '#1a9c6e',
        JUNGLE_8: '#16825c',
        JUNGLE_9: '#12694a',
        JUNGLE_10: '#0d4f38',

        /** Ocean */
        OCEAN_1: '#eaf7fc',
        OCEAN_2: '#b0e3f4',
        OCEAN_3: '#75cfec',
        OCEAN_4: '#3bbbe3',
        OCEAN_5: '#00a7db',
        OCEAN_6: '#0093c4',
        OCEAN_7: '#007fad',
        OCEAN_8: '#006c94',
        OCEAN_9: '#005a75',
        OCEAN_10: '#00465c',

        /** Mist */
        MIST_1: '#e6f4f7',
        MIST_2: '#c9e5ea',
        MIST_3: '#acd5dd',
        MIST_4: '#8fc6cf',
        MIST_5: '#6eadba',
        MIST_6: '#5f96a1',
        MIST_7: '#4f7e87',
        MIST_8: '#41666e',
        MIST_9: '#324e54',
        MIST_10: '#23373b',

        /** Magic */
        MAGIC_1: '#f2f4f9',
        MAGIC_2: '#d2d9ed',
        MAGIC_3: '#b2bee0',
        MAGIC_4: '#91a3d4',
        MAGIC_5: '#7188c7',
        MAGIC_6: '#516dbb',
        MAGIC_7: '#425ba1',
        MAGIC_8: '#334a88',
        MAGIC_9: '#24386e',
        MAGIC_10: '#002244',

        /** Eggplant */
        EGGPLANT_1: '#f6f1f9',
        EGGPLANT_2: '#ddcbe9',
        EGGPLANT_3: '#c4a4d9',
        EGGPLANT_4: '#ab7ec9',
        EGGPLANT_5: '#9258b9',
        EGGPLANT_6: '#7a4c98',
        EGGPLANT_7: '#684182',
        EGGPLANT_8: '#543469',
        EGGPLANT_9: '#3f284f',
        EGGPLANT_10: '#2b1b36',

        /** Sangria */
        SANGRIA_1: '#fdf2f5',
        SANGRIA_2: '#fbcada',
        SANGRIA_3: '#f8a2bf',
        SANGRIA_4: '#f57aa3',
        SANGRIA_5: '#f35288',
        SANGRIA_6: '#e53872',
        SANGRIA_7: '#d81e5d',
        SANGRIA_8: '#bf1b52',
        SANGRIA_9: '#a61747',
        SANGRIA_10: '#8c143c',

        /** Cloud */
        CLOUD_1: '#fafafa',
        CLOUD_2: '#f6f6f6',
        CLOUD_3: '#ececec',
        CLOUD_4: '#dadada',
        CLOUD_5: '#b3b3b3',
        CLOUD_6: '#949494',
        CLOUD_7: '#757575',
        CLOUD_8: '#646464',
        CLOUD_9: '#525252',
        CLOUD_10: '#3c3c3c',

        /** Iridium */
        IRIDIUM_1: '#F2F2F7',
        IRIDIUM_2: '#D4D4D9',
        IRIDIUM_3: '#B7B7BC',
        IRIDIUM_4: '#9A9A9F',
        IRIDIUM_5: '#7C7C81',
        IRIDIUM_6: '#5F5F64',
        IRIDIUM_7: '#424247',
        IRIDIUM_8: '#323239',
        IRIDIUM_9: '#2C2C2F',
        IRIDIUM_10: '#202022',

        /** Steel Gray */
        STEEL_GRAY_5: '#3b3b48',
        STEEL_GRAY_6: '#252532',
        STEEL_GRAY_7: '#1b1b26',

        /** Cherry */
        CHERRY_1: '#F54250',
        CHERRY_2: '#CC313D',

        /** Grass */
        GRASS_1: '#21A921',
        GRASS_2: '#0A870A'

    }
};

export default vstColors;
export const colors = vstColors.colors;
export const tints = vstColors.tints;